import type { MyVoucher } from '@/types/jobPaymentTypes';

export type MyVoucherStatus = 'active' | 'inactive' | 'expired' | 'upcoming';

export function getMyVoucherStatus(
  voucher: MyVoucher,
  now: Date = new Date()
): MyVoucherStatus {
  if (!voucher.isActive) return 'inactive';
  const from = new Date(voucher.validFrom);
  const to = new Date(voucher.validTo);
  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return 'inactive';
  if (now < from) return 'upcoming';
  if (now > to) return 'expired';
  return 'active';
}

/** Usable for quick-apply on pay / proposal (active + currently valid). */
export function isVoucherCurrentlyUsable(
  voucher: MyVoucher,
  now: Date = new Date()
): boolean {
  if (getMyVoucherStatus(voucher, now) !== 'active') return false;
  const max = voucher.maxUsage;
  if (max != null && Number(voucher.usageCount ?? 0) >= Number(max)) return false;
  return true;
}

export function filterUsableVouchersForAudience(
  vouchers: MyVoucher[],
  audience: 'client' | 'provider',
  now: Date = new Date()
): MyVoucher[] {
  return vouchers.filter(
    (v) => v.audience === audience && isVoucherCurrentlyUsable(v, now)
  );
}

export function formatVoucherDiscount(voucher: MyVoucher): string {
  const value = Number(voucher.discountValue);
  if (voucher.discountType === 'percentage') {
    return `${value}%`;
  }
  return `$${value.toFixed(2)}`;
}
